import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Organization Asset Leaderboard',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              filter: {
                and: [
                  {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  {
                    '!=': [
                      {
                        '@.': '!name',
                      },
                      'Innovation',
                    ],
                  },
                  {
                    '!=': [
                      {
                        '@.': '!name',
                      },
                      'Juran',
                    ],
                  },
                  {
                    '!=': [
                      {
                        '#': {
                          '@': 'assets',
                        },
                      },
                      0,
                    ],
                  },
                ],
              },
              target: 'dim::!org',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      numberAssets: {
                        '{}': {
                          value: {
                            '#': {
                              '@': 'assets',
                            },
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'asset.organization.table.details',
                                },
                              },
                              variables: {
                                '{}': {
                                  orgEntityId: {
                                    '@_': 'id',
                                  },
                                  orgRecordId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.slideout',
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                assets: {
                  ref: {
                    attr: 'attr:ent#!innovation_assets#!innovation_asset:!owner',
                  },
                  using: 'employees',
                  filter: {
                    '=': [
                      {
                        '@.': '!ai_enabled',
                      },
                      true,
                    ],
                  },
                  target: 'ent:!innovation_assets:!innovation_asset',
                  selection: {
                    '@.': '!name',
                  },
                },
                employees: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!org',
                    inherit: '-',
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'numberAssets',
                  direct: {
                    '{}': {
                      name: 'Number of Assets',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
